import { forwardRef, type Ref, type SVGProps } from "react";

function SvgStar(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.39 1.548a.677.677 0 0 1 1.22 0l1.448 3.011a.68.68 0 0 0 .521.376l3.333.436a.67.67 0 0 1 .376 1.154l-2.435 2.293a.67.67 0 0 0-.2.61l.612 3.276a.675.675 0 0 1-.986.713l-2.957-1.591a.68.68 0 0 0-.644 0l-2.957 1.591a.675.675 0 0 1-.986-.713l.612-3.276a.67.67 0 0 0-.2-.61L1.712 6.525a.67.67 0 0 1 .376-1.154l3.333-.436a.68.68 0 0 0 .52-.376z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgStar);
export default ForwardRef;
